import { FC } from "react";
import { useParams, Redirect } from "react-router-dom";
import * as _ from "lodash";

import { SectionEntity } from "@ctra/api";
import { CtraLayout, Skeleton } from "@ctra/components";

import { Routes } from "@routes";
import { LayoutProvider, SectionContext } from "@analytics";
import { ChartFilterContext } from "@chart";
import { useFarm } from "@farms";

import { testIds } from "../../../../testing";
import { Stack } from "../Stack";

const { AsyncLayout } = CtraLayout;

/**
 * Dashboard page with charts
 * @deprecated in favor of SectionDashboard
 * @constructor
 */
export const SectionDashboardPage: FC = () => {
  const { sectionSlug } = useParams<{ sectionSlug: SectionEntity["slug"] }>();
  const { farm } = useFarm();

  return (
    <LayoutProvider farmID={farm?.id}>
      {({ supportedSections }, { isLoading: isLayoutLoading }) => {
        /**
         * Find the section that matches the section slug in the url
         */
        const section = _.find(supportedSections, (section) => section.slug === sectionSlug);

        /**
         * If the section is not found in the newly loaded layout, redirect to the analytics index page
         */
        if (!section && !isLayoutLoading) {
          return <Redirect to={Routes.app.analytics.index} />;
        }

        return (
          <AsyncLayout loading={isLayoutLoading} data-testid={testIds.sectionDashboard}>
            <Skeleton active loading={isLayoutLoading}>
              <ChartFilterContext.Provider>
                <SectionContext.Provider sectionID={section?.id}>
                  <Stack />
                </SectionContext.Provider>
              </ChartFilterContext.Provider>
            </Skeleton>
          </AsyncLayout>
        );
      }}
    </LayoutProvider>
  );
};
